import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { Button, Stack, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh }) => {
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState(data?.description || '')
  const [path, setPath] = useState(data?.path || '')

  // const [video, setVideo] = useState(data?.video || '')
  // const [transcription, setTranscription] = useState(data?.transcription || '')
  const [images, setImages] = useState([])
  const uploadImage = useUploadImage()
  const AppService = useAppServices()

  useEffect(() => {
    if (data?.image) {
      setImages(Array.isArray(data.image) ? data.image : [data.image])
    }
  }, [data])

  const handleModal = () => setOpenEditProduct(true)
  const closeModal = () => setOpenEditProduct(false)

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files)
    setImages((prev) => [...prev, ...selectedFiles])
  }

  const handleRemove = (idx) => {
    setImages((prev) => prev.filter((_, i) => i !== idx))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    let imageResponses = []
    const filesToUpload = images.filter((item) => item instanceof File)
    if (filesToUpload.length) {
      imageResponses = await Promise.all(
        filesToUpload.map((file) => uploadImage({ file, desiredPath: 'app/logo/image' }))
      )
    }

    const uploadedUrls = imageResponses.map((r) => r?.response?.data)
    // Keep existing URLs (strings) if not replaced
    const existingUrls = images.filter((item) => typeof item === 'string')

    const payload = {
      description,
      // video,
      // transcription,
      image: [...existingUrls, ...uploadedUrls],
      path: path,
      type: e.target.type.value,
    }

    const { response } = await AppService.aisupprortkb.update({
      query: `_id=${data._id}`,
      payload,
    })

    if (response) {
      setProcessing(false)
      closeModal()
      handleRefresh()
    } else {
      setProcessing(false)
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeModal}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Edit Ai Support Knowledge Base
          </MDTypography>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button variant="contained" component="label" sx={{ color: '#fff' }}>
              Upload Images +
              <input hidden multiple name="images" type="file" onChange={handleImageChange} />
            </Button>
          </Stack>
          {images.map((item, idx) => {
            const isFile = item instanceof File
            const preview = isFile ? URL.createObjectURL(item) : item
            return (
              <MDBox
                key={idx}
                sx={{
                  position: 'relative',
                  display: 'inline-block',
                  marginTop: 2,
                  marginRight: 2,
                }}
              >
                <img
                  src={preview}
                  alt="preview"
                  style={{
                    width: 60,
                    height: 60,
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'white',
                    ':hover': { backgroundColor: 'red' },
                  }}
                  onClick={() => handleRemove(idx)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </MDBox>
            )
          })}
          <MDBox mb={2} mt={2}>
            <MDTypography variant="button">Description</MDTypography>
            <Editor handleChange={setDescription} data={description} />
          </MDBox>
          <MDBox mb={2}>
            <MDTypography variant="button">Path</MDTypography>
            <MDInput
              name="path"
              fullWidth
              value={path}
              onChange={(e) => setPath(e.target.value)}
            />
          </MDBox>
          {/* <MDBox mb={2}>
            <MDTypography variant="button">Video</MDTypography>
            <MDInput
              name="video"
              fullWidth
              value={video}
              onChange={(e) => setVideo(e.target.value)}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDTypography variant="button">Transcription</MDTypography>
            <Editor handleChange={setTranscription} data={transcription} />
          </MDBox> */}

          <MDBox mb={2}>
            <MDTypography variant="button">Type</MDTypography>
            <MDInput
              select
              name="type"
              fullWidth
              defaultValue={data.type}
              SelectProps={{ native: true }}
            >
              <option value="agency">Agency </option>
              <option value="subaccount">Sub Account</option>
            </MDInput>
          </MDBox>

          <MDBox display="flex" justifyContent="flex-end">
            <MDButton
              variant="gradient"
              color="primary"
              type="button"
              sx={{ mt: 2, mb: 1 }}
              onClick={closeModal}
            >
              Close
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ mt: 2, mb: 1, ml: 1 }}
              disabled={processing}
            >
              Save
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
